/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

export const addAtPrefix = (obj: unknown): unknown => {
  if (Array.isArray(obj)) {
    return obj.map(addAtPrefix);
  }
  if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj as Record<string, unknown>).map(([k, v]) => {
        const newKey =
          k === 'type' ? '@type' : k === 'id' ? '@id' : k === 'context' ? '@context' : k;
        return [newKey, addAtPrefix(v)];
      }),
    );
  }
  return obj;
};
